// SignUp.jsx
import "./newSignUp.css";
import coverimage from "../../../assets/loginCover.png";
import BhuMeetLogo from "../../../assets/bhumeet.svg";
import BasicInfoStep from "./BasicInfoStep";
import EmailDetailsStep from "./EmailDetailsStep";   // now only “enter + switch mode”
import EmailVerifyStep from "./EmailVerifyStep";     // still a component, but used conditionally
import PhoneDetailsStep from "./PhoneDetailsStep";
import PhoneVerifyStep from "./PhoneVerifyStep";
import { useSignUpContext } from "../../../context/SignUpContext";
import ArrowIcon from "../../../assets/arrowleft.svg";
import { useNavigate } from "react-router";
import WelcomeStep from "./WelcomeStep";



export default function SignUp() {
  const navigate = useNavigate();
  const { currentStep,
    setCurrentStep,
    signUpDetails,
    setSignUpDetails,
    emailMode,
    setEmailMode,
    phoneMode,
    setPhoneMode, } = useSignUpContext();

  const stepComponents = {
    1: (emailMode) => emailMode === "ENTER" ? <EmailDetailsStep /> : <EmailVerifyStep />,
    2: (phoneMode) => phoneMode === "ENTER" ? <PhoneDetailsStep /> : <PhoneVerifyStep />,
    3: () => <BasicInfoStep />
  };

  const renderStep = () => {
    const stepRenderer = stepComponents[currentStep];

    if (!stepRenderer) return <EmailDetailsStep />;

    if (currentStep === 1) return stepRenderer(emailMode);
    if (currentStep === 2) return stepRenderer(phoneMode);

    return stepRenderer();
  };
  const handleBack = () => {
    // Back behavior depends on mode and step
    if (currentStep === 1) {
      if (emailMode === "VERIFY") {
        setEmailMode("ENTER")
      } else {
        navigate("/login");
      }
      return;
    }

    if (currentStep === 2) {
      if (phoneMode === "VERIFY") {
        setPhoneMode("ENTER");
      } else {
        setCurrentStep(1);
      }
      return;
    }

    if (currentStep === 3) {
      // from BasicInfo → phone step (probably VERIFY or ENTER depending on isMobileVerified)
      setCurrentStep(2);
      return;
    }
  };

  return (
    <div className="signupform-container">
      <div className="first_section">
        <div className="banner-heading-wrapper">
          <p className="banner-heading">
            Simplest way to manage your drone business
          </p>
          <span className="banner-sub-heading">
            Sign up now and explore more
          </span>
        </div>
        <img src={coverimage} alt="Cover" className="cover-image" />
      </div>

      <div className="second_section">
        {currentStep < 4 ?
          <>
            <div className="topbar-wrapper">
              <div onClick={handleBack} className="back-btn">
                <img src={ArrowIcon} alt="back" className="cursor-pointer" />
                <span >Back</span>
              </div>

              <div className="step-status font-manrope">Step {currentStep} of 3</div>
            </div>

            <div className="form_wrapper">
              <div
                style={{
                  marginBottom: "20px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  marginLeft: "80px",
                }}
              >
                <img src={BhuMeetLogo} alt="BhuMeet Logo" height={70} width={70} />
              </div>

              <div className="signup-form-wrapper">
                <div className="step-container" key={currentStep}>
                  {renderStep()}
                </div>
              </div>
            </div>
          </> :
          <div className="step-container">
            <WelcomeStep />
          </div>
        }

      </div>
    </div >
  );
}
